import React, { useEffect, useState } from 'react';
import DatePicker from 'react-date-picker';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import { Value } from 'react-date-picker/dist/cjs/shared/types';

type BDPProps = {
  onChange?: Function;
  disabled?: boolean;
  initialDate?: Date | string | null;
};

const BasicDatePicker: React.FC<BDPProps> = ({
  onChange = () => {},
  disabled = false,
  initialDate = null,
}) => {
  const [date, setDate] = useState<Date | null>(null);

  useEffect(() => {
    setDate(
      !initialDate || initialDate === 'none' ? null : new Date(initialDate)
    );
  }, [initialDate]);

  return (
    <div className={`datepicker-wrapper ${disabled ? 'disabled' : ''}`}>
      <DatePicker
        calendarIcon={
          <i
            className={`fa-light fa-calendar-days ${
              disabled ? 'disabled' : 'clickable'
            }`}
          />
        }
        clearIcon={null}
        maxDate={new Date('9999-12-31')}
        onChange={(newDate: Value) => {
          if (newDate) {
            setDate(newDate as Date);
            onChange(newDate);
          } else {
            const initialDateState =
              !initialDate || initialDate === 'none'
                ? null
                : new Date(initialDate);
            setDate(initialDateState);
            onChange(initialDateState);
          }
        }}
        value={date}
        openCalendarOnFocus={false}
        calendarProps={{ calendarType: 'gregory' }}
        monthPlaceholder="mm"
        dayPlaceholder="dd"
        yearPlaceholder="yyyy"
        disabled={disabled}
      />
    </div>
  );
};

export default BasicDatePicker;
